// extracted by mini-css-extract-plugin
export default {"container":"ProductContainer_container__hdps1","container-3":"ProductContainer_container-3__7vmPg ProductContainer_container__hdps1"};